import type { AppointmentSlot } from './reducer'
function localParts(date: Date, timeZone: string): string {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(date)
  const get = (type: string) => parts.find(part => part.type === type)?.value
  return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}`
}
export function slotToLocal(slot: AppointmentSlot | null, timeZone: string): string {
  try { return slot ? localParts(new Date(slot.startsAt), timeZone) : '' } catch { return '' }
}
export function slotFromLocal(value: string, timeZone: string): AppointmentSlot | null {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) return null
  try {
    const wall = Date.parse(`${value}:00Z`)
    let instant = wall
    for (let i = 0; i < 3; i++) instant += wall - Date.parse(`${localParts(new Date(instant), timeZone)}:00Z`)
    if (localParts(new Date(instant), timeZone) !== value) return null
    return { startsAt: new Date(instant).toISOString(), timeZone }
  } catch { return null }
}
